
export type LoginFlowStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  form_classname: string
  form_inner_classname: string
  form_alert_classname: string
  form_group_classname: string
  form_group_checkbox_classname: string
  form_group_radio_classname: string
  form_checkbox_classname: string
  form_radio_classname: string
  form_select_classname: string
  form_label_classname: string
  form_input_classname: string
  form_input_password_classname: string
  form_input_error_classname: string
  form_error_classname: string
  form_description_classname: string
  form_actions_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
  clickable_tertiary_classname: string
  footer_classname: string
  footer_item_classname: string
}>

export const LoginFlowClasses: LoginFlowStyle = {
  block_classname: "form form--login",
  inner_classname: "form__inner",
  header_classname: "header__brand",
  title_classname: "sr-text",
  intro_classname: "form__text text--m",
  form_classname: "form__form",
  form_inner_classname: "form__form-inner",
  form_alert_classname: "form__alert alert",
  form_group_classname: "form__group",
  form_group_checkbox_classname: "form__group form__group--checkbox",
  form_group_radio_classname: "form__group form__group--radio",
  form_checkbox_classname: "form__boolean form__checkbox",
  form_radio_classname: "form__boolean form__radio",
  form_select_classname: "form__select",
  form_label_classname: "form__label",
  form_input_classname: "form__input",
  form_input_password_classname: "form__input form__input--password",
  form_input_error_classname: "form__description form__description--input form__error",
  form_error_classname: "form__description form__error",
  form_description_classname: "form__description",
  form_actions_classname: "form__actions",
  clickable_primary_classname: "button button--primary",
  clickable_secondary_classname: "link--m",
  footer_classname: "form__footer",
  footer_item_classname: "form__footer-item",
}
